import { IAngularEvent, IRootScopeService } from 'angular';
import { BehaviorSubject } from 'rxjs';

export class Paginator {
    protected _itemCount = 0;
    protected _perPage = 20;
    protected _page = 1;
    protected _pages = 1;

    public page$: BehaviorSubject<number>;

    constructor(perPage = 20, page = 1) {
        this.perPage = perPage;
        this.page = page;
        this.page$ = new BehaviorSubject<number>(page);
        this.itemCount = perPage * page;
        // console.log('Paginator', { perPage, page });
    }

    public set itemCount(count: number) {
        const _count = Math.max(count, 0);
        this._itemCount = _count;
        this._pages = Math.ceil(count / this._perPage);
        // re-assign page to ensure it is within bounds.
        const page = this.page;
        this.page = page;
    }

    public get itemCount(): number {
        return this._itemCount;
    }

    public set perPage(perPage: number) {
        const _perPage = Math.max(perPage, 1);
        this._perPage = _perPage;
        this._pages = Math.ceil(this._itemCount / perPage);
        // re-assign page to ensure it is within bounds.
        const page = this.page;
        this.page = page;
    }

    public get perPage(): number {
        return this._perPage;
    }

    public set page(page: number) {
        const _page = Math.max(1, Math.min(this._pages, page));
        if (_page != this._page) {
            this._page = _page;
            this.page$.next(this.page);
        }
        this._page = _page;
    }

    public get page(): number {
        return this._page;
    }

    public get pages(): number {
        return this._pages;
    }

    checkIdxOnPage(idx: number): boolean {
        const pageStart = (this.page - 1) * this.perPage;
        const pageEnd = this.page * this.perPage;
        return idx >= pageStart && idx < pageEnd;
    }

    nextPage(): number {
        return (this.page = this.page + 1);
    }

    prevPage(): number {
        return (this.page = this.page - 1);
    }
}

// uses 0 indexed pages
export class ItemsPaginator {
    protected _pages = 1;
    protected _items: unknown[] = [];
    protected _perPage = 20;
    protected _page = 1;

    protected set pages(pages: number) {
        // ensure page count is at least 1
        this._pages = Math.max(pages, 1);
    }

    get pages(): number {
        return this._pages;
    }

    set items(items: unknown[]) {
        this._items = items;
        this.pages = Math.ceil(items.length / this._perPage);
        // clamp page on items change.
        const page = this.page;
        this.page = page;
    }

    get items(): unknown[] {
        return this._items;
    }

    set perPage(perPage: number) {
        // ensure perPage is at least 1
        this._perPage = Math.max(perPage, 1);
        // recalculate pages, rounding up.
        this.pages = Math.ceil(this._items.length / this._perPage);
    }

    get perPage(): number {
        return this._perPage;
    }

    get page(): number {
        return this._page;
    }
    protected set page(page: number) {
        const _page = Math.min(this._pages, Math.max(0, page));
        if (_page == this._page) {
            this._page = _page;
            this._emitPage();
        }
    }

    constructor(protected $rootScope: IRootScopeService) {}

    protected _emitPage(): void {
        // console.log('_emitPage', this._page);
        this.$rootScope.$emit('paginator::page', this._page);
    }

    public onPage(
        callback: (event: IAngularEvent, page: number) => void
    ): () => void {
        // console.log('onPage', callback);
        return this.$rootScope.$on('paginator::page', callback);
    }

    prevPage(): number {
        return (this.page = this._page - 1);
    }

    nextPage(): number {
        return (this.page = this._page + 1);
    }
}
